import { DataTable } from "carbon-components-react";
import React from "react";
import { useSelector } from "react-redux";
import DeleteTeamsModal from "./DeleteTeamsModal";
import UpdateTeamsModal from "./UpdateTeamsModal";
import { LoadingIndicator } from "../../components";
import { getTeamsData, getTeamsIsFetching } from "../../selectors";

const {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  TableHeader,
} = DataTable;

const headers = [
  {
    header: "Team Name",
    key: "team_name",
  },
  {
    header: "First Name",
    key: "first_name",
  },
  {
    header: "Last Name",
    key: "last_name",
  },
  {
    header: "Cell Phone",
    key: "cell_phone",
  },
  {
    header: "Email",
    key: "email",
  },
];

const TeamsTable = () => {
  const teamsDataIsFetching = useSelector(getTeamsIsFetching);
  const teamsData = useSelector(getTeamsData);

  return (
    <div style={{ backgroundColor: "#e0e0e0" }}>
      <LoadingIndicator active={teamsDataIsFetching} />
      <DataTable
        rows={teamsData}
        headers={headers}
        isSortable={true}
        render={({ rows, headers, getHeaderProps }) => (
          <TableContainer title="Teams">
            <Table>
              <TableHead>
                <TableRow>
                  {headers.map((header) => (
                    // eslint-disable-next-line react/jsx-key
                    <TableHeader {...getHeaderProps({ header })}>
                      {header.header}
                    </TableHeader>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.id}>
                    {row.cells.map((cell) => (
                      <TableCell key={cell.id}>{cell.value}</TableCell>
                    ))}
                    <TableCell>
                      <DeleteTeamsModal team={row} />
                    </TableCell>
                    <TableCell>
                      <UpdateTeamsModal team={row} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      />
    </div>
  );
};

export default TeamsTable;
